const STATS = ['hp', 'atk', 'def', 'speed', 'spatk', 'spdef'];

const STAT_NAMES = {
	'hp': "HP",
	'atk': "Attack",
	'def': "Defence",
	'speed': "Speed",
	'spatk': "Special Attack",
	'spdef': "Special Defence",
	'bst': "Base Stat Total"
}
const STAT_NAMES_SHORT = {
	'hp': "HP",
	'atk': "Atk",
	'def': "Def",
	'speed': "Spd",
	'spatk': "Sp.Atk",
	'spdef': "Sp.Def",
	'bst': "BST"
}

const prevStat = (stat) => {
return STATS[(STATS.indexOf(stat) - 1 + 6) % 6]
};
  const nextStat = (stat) => {
return STATS[(STATS.indexOf(stat) + 1) % 6]
};

export { STATS, STAT_NAMES, STAT_NAMES_SHORT, prevStat, nextStat };
